<!-- Popover template -->
<ng-template #lotPopover let-close="close">
  <div class="border-8 up-4 container-background-reverse-alt p-12 flex-col gap-12 border-primary">
    <div class="flex-col w100">
      <div class="flex-row w100">
        <mat-icon class="ml-auto cursor-pointer on-background-reverse" (click)="close?.()">close</mat-icon>
      </div>
      <div class="flex-col gap-4">
        <span class="on-background-reverse">{{ lot().lotUnique ? ('lot.unique' | trans) : lot().numero }}</span>
        @if (formattedDluo()) {
          <span [ngClass]="'dlc-' + dlcStatus()" class="body-2">{{ formattedDluo() }}</span>
        }
      </div>
    </div>

    <vl-big-button (action)="onGoArticle(); close?.()" [text]="'article.goToArticle' | trans" icon="link" color="accent"/>
    @if (hasOf()) {
      <vl-big-button (action)="onGoOf(); close?.()" [text]="'lot.goToOf' | trans" icon="precision_manufacturing" color="accent"/>
    }
    @if (hasCommande()) {
      <vl-big-button (action)="onGoCommande(); close?.()" [text]="'lot.goToCommande' | trans" icon="local_shipping" color="accent"/>
    }
    <vl-big-button (action)="onGoLot(); close?.()" [text]="'lot.page' | trans" icon="inventory_2" color="accent"/>
  </div>
</ng-template>

@if (lot?.()) {
  @if (mode() === 'chips') {
    @if (lot().lotUnique) {
      <vl-chips state="secondary" [iconRight]="noAction() ? '' : 'link_2'" size="small" [contentHeight]="true"
                [cursor]="noAction() ? 'default' : 'pointer'"
                [popoverTrigger]="lotPopover"
                [popoverDisabled]="noAction()"
                [closeOnClickOutside]="true"
                (click)="onOpenPopover()">{{ 'lot.unique' | trans }}
      </vl-chips>
    } @else {
      <vl-chips [iconRight]="noAction() ? '' : 'link_2'" size="small" state="enabled" [contentHeight]="true"
                [cursor]="noAction() ? 'default' : 'pointer'"
                [popoverTrigger]="lotPopover"
                [popoverDisabled]="noAction()"
                [closeOnClickOutside]="true"
                (click)="onOpenPopover()">{{ lot().numero }}
      </vl-chips>
    }
  } @else if (mode() === 'text') {
    <div class="flex-row gap-4" [ngClass]="noAction() ? '' : 'link-primary'"
         [popoverTrigger]="lotPopover"
         [popoverDisabled]="noAction()"
         [closeOnClickOutside]="true"
         (click)="onOpenPopover()">
      <span class="body-2 flex-row align-center lot-number">
        {{ lot().numero }}
      </span>
      @if (!noAction()) {
        <mat-icon>link_2</mat-icon>
      }
    </div>
  } @else if (mode() === 'detail') {
    <div class="lot-detail"
         [popoverTrigger]="lotPopover"
         [popoverDisabled]="noAction()"
         [closeOnClickOutside]="true"
         (click)="onOpenPopover()">
      <span class="lot-detail__numero">{{ lot().lotUnique ? ('lot.unique' | trans) : lot().numero }}</span>
      @if (lot().dluo) {
        <vl-date-limite-display
          [dluo]="lot().dluo"
          [typeDateLimite]="lot().typeDateLimite"
          [format]="dluoFormat()"
          size="compact"/>
      }
    </div>
  }
} @else {
  <vl-chips state="loading">{{ 'button.loading' | trans }}</vl-chips>
}
